import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const LogosView = styled.div`
  display: flex;
`

const InnerLogosView = styled.div`
  display: flex;
  align-items: center;
`

const AdditionalIconsView = styled(InnerLogosView)`
  display: none;

  ${breakpoint('mobile')`
    display: flex;
    align-items: center;
  `};
`

export {LogosView, InnerLogosView, AdditionalIconsView}
